module.exports = __webpack_public_path__ + "static/media/icon-booth-housing.c5d2257e.svg";